import * as React from "react";
function SvgUsers2Filled(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      ref={svgRef}
      {...props}
    >
      <path d="M12.4 13h3a3.64 3.64 0 013.6 3.68V19H1v-2.71A4.37 4.37 0 015.43 12h4.14a4.47 4.47 0 012.83 1z" />
      <circle cx={14.5} cy={9.5} r={2.5} />
      <circle cx={7.5} cy={8} r={3.25} />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgUsers2Filled);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
